<script src="job-details.component.ts"></script>
<div class="container-all" style="margin: 10px;">
  <div style="margin-bottom: 10px; margin-top: 20px;">
    <button class="margin" type="button" pButton label="Go Back" (click)="goBack()" >
    </button>
  </div>

  <app-execution-details></app-execution-details>
  <!--  Graph-->

</div>
